(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sbn-acc-gallery"] && !Shopify.designMode) return;
  try {
    
(function() {
  const section = document.getElementById('sbn-acc-gal-{{ section.id }}');
  if (!section) return;

  const slides = section.querySelectorAll('.sbn-acc-gal__slide');
  const thumbs = section.querySelectorAll('.sbn-acc-gal__thumb');
  const curEl  = section.querySelector('.sbn-acc-gal__counter-cur');
  const total  = slides.length;
  let current  = 0;

  function goTo(idx) {
    if (idx < 0) idx = total - 1;
    if (idx >= total) idx = 0;
    slides[current]?.classList.remove('is-active');
    thumbs[current]?.classList.remove('is-active');
    current = idx;
    slides[current]?.classList.add('is-active');
    thumbs[current]?.classList.add('is-active');
    if (curEl) curEl.textContent = current + 1;
    // scroll thumb into view
    thumbs[current]?.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }

  // Thumb clicks
  thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));

  // Arrow clicks
  section.querySelector('.sbn-acc-gal__arrow--prev')?.addEventListener('click', () => goTo(current - 1));
  section.querySelector('.sbn-acc-gal__arrow--next')?.addEventListener('click', () => goTo(current + 1));

  // Touch swipe on main stage
  const stage = section.querySelector('.sbn-acc-gal__stage');
  let startX = 0;
  stage?.addEventListener('touchstart', e => { startX = e.touches[0].clientX; }, { passive: true });
  stage?.addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - startX;
    if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
  }, { passive: true });

  // Quantity +/- buttons
  const qtyInput = section.querySelector('.sbn-acc-gal__qty-input');
  section.querySelectorAll('.sbn-acc-gal__qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      let val = parseInt(qtyInput.value, 10) || 1;
      if (btn.dataset.action === 'plus') val++;
      else if (btn.dataset.action === 'minus') val = Math.max(1, val - 1);
      qtyInput.value = val;
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
